import { useState } from 'react';
import { Container, Nav, Navbar } from 'react-bootstrap';

import { Link } from 'react-router-dom';

const MainBar = ({ brand = '', left = '', right = '', autenticado }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <>
      <Navbar className="navbar-poncho" expand="md">
        <Container>
          <Navbar.Toggle
            className="text-primary"
            aria-controls="navbar-nav"
            label={isExpanded ? 'Colapsar Navegacion' : 'Desplegar Navegacion'}
            onClick={() => setIsExpanded(!isExpanded)}>
            <i className="fa fa-navicon"></i>
          </Navbar.Toggle>
          <Navbar.Brand className="font-weight-bold ml-sm-2">
            {autenticado ? (
              <Nav.Link as={Link} to="/" style={{ padding: 0 }}>
                {brand}
              </Nav.Link>
            ) : (
              <div style={{ padding: 0 }}>{brand}</div>
            )}
          </Navbar.Brand>
          <Navbar.Collapse id="navbar-nav">
            <Nav className="mr-auto">{left}</Nav>
            <Nav>{right}</Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
};

export default MainBar;
